import { render, staticRenderFns } from "./about.vue?vue&type=template&id=a5f7fd1e&scoped=true&"
import script from "./about.vue?vue&type=script&lang=ts&"
export * from "./about.vue?vue&type=script&lang=ts&"
import style0 from "./about.vue?vue&type=style&index=0&id=a5f7fd1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f7fd1e",
  null
  
)

component.options.__file = "about.vue"
export default component.exports